import { BrowserRouter, Routes, Route } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css"; // Importa o CSS do Bootstrap
import Layout from "./components/Layout";
import Login from "./pages/Login";
import CreateUser from "./pages/CreateUser";
import AdminRoute from "./components/AdminRoute";
import SuperAdminRoute from "./components/SuperAdminRoute";
import AuthWrapper from "./components/AuthWrapper"; // Importa o novo componente
import Dashboard from "./pages/Dashboard";
import CreateProducts from "./pages/CreateProducts";
import EditProducts from "./pages/EditProducts";
import Expediction from "./pages/Expediction";
import ExpeditionDetails from "./pages/ExpeditionDetails";
import EditExpedition from "./pages/EditExpedition";
import ForgetPass from "./pages/ForgetPass";
import UpdatePassword from "./pages/UpdatePassword";
import NewProduction from "./pages/NewProduction";
import ProductDetails from "./pages/ProductDetails";
import Production from "./pages/Production";
import ProductionDetails from "./pages/ProductionDetails";
import ProductionDrafts from "./pages/ProductionDrafts";
import Reports from "./pages/Reports";
import Orders from "./pages/Orders"; // Import Orders component
import CreateOrder from "./pages/CreateOrder"; // Import CreateOrder component
import OrderDetails from "./pages/OrderDetails"; // Import OrderDetails component
import Stock from "./pages/Stock"; // Import Stock component
import CreateStockEntry from "./pages/CreateStockEntry"; // Import CreateStockEntry component
import StockDetails from "./pages/StockDetails"; // Import StockDetails component
import Profile from "./pages/Profile"; // Import Profile component
import Clients from "./pages/Clients"; // Import Clients component
import CreateClient from "./pages/CreateClient"; // Import CreateClient component
import UserRoleDebug from "./pages/UserRoleDebug"; // Import UserRoleDebug component
import Dev from "./pages/Dev"; // Import Dev component for development tools
import ProductionFormulas from "./pages/admin/ProductionFormulas"; // Import ProductionFormulas component
import RecurringOrdersAdmin from "./pages/admin/RecurringOrdersAdmin"; // Import RecurringOrdersAdmin component
import { Toaster } from "react-hot-toast";
import ErrorBoundary from "./components/ErrorBoundary";
import { AuthProvider, useAuth } from "./contexts/AuthContext"; // Importa AuthProvider e useAuth
import LoadingSpinner from "./components/LoadingSpinner"; // Importa LoadingSpinner

function App() {
  return (
    <AuthProvider>
      {" "}
      {/* Envolve toda a aplicação com AuthProvider */}
      <AppContent />
    </AuthProvider>
  );
}

function AppContent() {
  const { isLoading } = useAuth(); // Obtém o estado de carregamento do AuthContext

  if (isLoading) {
    return <LoadingSpinner />; // Exibe spinner enquanto carrega
  }

  return (
    <BrowserRouter>
      <Toaster />
      <Routes>
        {/* Public routes */}
        <Route
          path="/"
          element={
            <AuthWrapper>
              <Login />
            </AuthWrapper>
          }
        />
        <Route path="/forget-password" element={<ForgetPass />} />
        <Route path="/update-password" element={<UpdatePassword />} />

        {/* Super-admin only routes (vista simplificada para utilizadores tipo Graziela) */}
        <Route element={<Layout />}>
          <Route element={<SuperAdminRoute />}>
            {/* Rota duplicada para super-admins sem role=admin (ex: Graziela) */}
          </Route>
        </Route>

        {/* Protected routes using Layout */}
        <Route element={<Layout />}>
          <Route path="/dashboard" element={<Dashboard />} />

          {/* Admin-only routes */}
          <Route element={<AdminRoute />}>
            {/* Debug route: expõe app_metadata/user_metadata do utilizador — só admin (#109) */}
            <Route path="/debug-role" element={<UserRoleDebug />} />
            <Route path="/create-user" element={<CreateUser />} />
            <Route path="/clients" element={<Clients />} />
            <Route path="/create-client" element={<CreateClient />} />
            <Route path="/edit-client/:id" element={<CreateClient />} />
            <Route path="/production-formulas" element={<ProductionFormulas />} />
            <Route path="/recurring-admin" element={<RecurringOrdersAdmin />} />
            <Route path="/dev" element={<Dev />} />
          </Route>
          <Route path="/profile" element={<Profile />} />
          <Route path="/create-products" element={<CreateProducts />} />
          <Route path="/edit-product/:id" element={<EditProducts />} />{" "}
          {/* Alterado para singular */}
          <Route path="/expedition" element={<Expediction />} />
          <Route
            path="/expedition-details/:id"
            element={<ExpeditionDetails />}
          />
          <Route path="/edit-expedition/:id" element={<EditExpedition />} />
          <Route path="/new-production" element={<NewProduction />} />
          <Route
            path="/product-details/:id"
            element={
              <ErrorBoundary>
                <ProductDetails />
              </ErrorBoundary>
            }
          />
          <Route path="/production" element={<Production />} />
          <Route
            path="/production-details/:id"
            element={<ProductionDetails />}
          />
          <Route path="/production-drafts" element={<ProductionDrafts />} />
          {/* Removida a rota /products antiga, pois a página de stock agora exibe os produtos */}
          <Route path="/reports" element={<Reports />} />
          <Route path="/orders" element={<Orders />} />{" "}
          {/* New route for Orders list */}
          <Route path="/create-order" element={<CreateOrder />} />{" "}
          {/* New route for Create Order */}
          <Route path="/order-details/:id" element={<OrderDetails />} />{" "}
          {/* New route for Order Details */}
          <Route path="/stock" element={<Stock />} />{" "}
          {/* New route for Stock list */}
          <Route
            path="/create-stock-entry"
            element={<CreateStockEntry />}
          />{" "}
          {/* New route for Create Stock Entry */}
          <Route path="/stock-details/:id" element={<StockDetails />} />{" "}
          {/* New route for Stock Details */}
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
